/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConsultationStrictHttpResponse } from '../../consultation-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterModel } from '../../models/encounter-model';

export interface EncounterPractitionerEncountersPractitionerFhirIdGet$Params {
  practitionerFhirId: string;
}

export function encounterPractitionerEncountersPractitionerFhirIdGet(http: HttpClient, rootUrl: string, params: EncounterPractitionerEncountersPractitionerFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<Array<EncounterModel>>> {
  const rb = new RequestBuilder(rootUrl, encounterPractitionerEncountersPractitionerFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('practitionerFhirId', params.practitionerFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ConsultationStrictHttpResponse<Array<EncounterModel>>;
    })
  );
}

encounterPractitionerEncountersPractitionerFhirIdGet.PATH = '/Encounter/PractitionerEncounters/{practitionerFhirId}';
